import { DatePicker, Radio, Select, Typography } from "antd";
import { React, useEffect, useState } from "react";

import "./FiltersPanel.css";
import { useDispatch, useSelector } from "react-redux";
import { setTopFilters } from "../../../store/slices/dashboardSlice";
import { useParams } from "react-router-dom";

const { Paragraph } = Typography;
const style = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
};

const adjustToUTC = (date, isEndOfDay = false) => {
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    if (isEndOfDay) {
        utcDate.setUTCHours(23, 59, 59, 999);
    } else {
        utcDate.setUTCHours(0, 0, 0, 0);
    }
    return date;
};

const adjustToUTC2 = (date, isEndOfDay = false) => {
    const utcDate = new Date(date.getTime() + date.getTimezoneOffset());
    if (isEndOfDay) {
        utcDate.setUTCHours(23, 59, 59, 999);
    } else {
        utcDate.setUTCHours(0, 0, 0, 0);
    }
    return utcDate;
};

export const DatesFilterContent = ({ metadata }) => {
    const [value, setValue] = useState(1);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    const dispatch = useDispatch();
    const { id } = useParams();
    const { topFilters } = useSelector((state) => {
        return state.dashboard[id] || {};
    });

    const onChange = (e) => {
        setValue(e.target.value);
        if (e.target.value !== value) {
            setFromDate(undefined);
            setToDate(undefined);
        }
    };

    const handleChangePresetRange = (_, option) => {
        setFromDate(option.data.startDate);
        setToDate(option.data.endDate);
    };

    const presetRanges = [
        {
            label: "Today",
            value: "Today",
            data: {
                startDate: adjustToUTC(new Date()),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Yesterday",
            value: "Yesterday",
            data: {
                startDate: adjustToUTC(new Date(Date.now() - 86400000)),
                endDate: adjustToUTC(new Date(Date.now() - 86400000), true),
            },
        },
        {
            label: "This week",
            value: "This week",
            data: {
                startDate: adjustToUTC(
                    new Date(Date.now() - new Date().getDay() * 86400000)
                ),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last week",
            value: "Last week",
            data: {
                startDate: adjustToUTC(
                    new Date(Date.now() - (new Date().getDay() + 7) * 86400000)
                ),
                endDate: adjustToUTC(
                    new Date(Date.now() - new Date().getDay() * 86400000),
                    true
                ),
            },
        },
        {
            label: "This month",
            value: "This month",
            data: {
                startDate: adjustToUTC(
                    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
                ),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last month",
            value: "Last month",
            data: {
                startDate: adjustToUTC(
                    new Date(
                        new Date().getFullYear(),
                        new Date().getMonth() - 1,
                        1
                    )
                ),
                endDate: adjustToUTC(
                    new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        0
                    ),
                    true
                ),
            },
        },
        {
            label: "Last 90 days",
            value: "Last 90 days",
            data: {
                startDate: adjustToUTC(new Date(Date.now() - 90 * 86400000)),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "This year",
            value: "This year",
            data: {
                startDate: adjustToUTC(
                    new Date(new Date().getFullYear(), 0, 1)
                ),
                endDate: adjustToUTC(new Date(), true),
            },
        },
        {
            label: "Last year",
            value: "Last year",
            data: {
                startDate: adjustToUTC(
                    new Date(new Date().getFullYear() - 1, 0, 1)
                ),
                endDate: adjustToUTC(
                    new Date(new Date().getFullYear() - 1, 11, 31),
                    true
                ),
            },
        },
        {
            label: "All the time",
            value: "All the time",
            data: {
                startDate: adjustToUTC(new Date(metadata?.minimum)),
                endDate: adjustToUTC(new Date(metadata?.maximum), true),
            },
        },
    ];

    const handleChangeFromDate = (date) => {
        setFromDate(adjustToUTC(new Date(date)));
    };

    const handleChangeToDate = (date) => {
        setToDate(adjustToUTC(new Date(date)));
    };

    useEffect(() => {
        if (fromDate && toDate) {
            console.log("fromDate=>", fromDate);
            console.log("toDate=>", toDate);
            let minimum = fromDate.toISOString();
            minimum = adjustToUTC2(fromDate);
            let maximum = toDate.toISOString();
            maximum = adjustToUTC2(toDate, true);
            const newFilter = { name: metadata.name, minimum, maximum };
            // const newFilter = { name, minimum, maximum };
            dispatch(
                setTopFilters({
                    id,
                    filters: (topFilters || [])
                        .filter((filter) => filter.name !== metadata.name)
                        .concat(newFilter),
                })
            );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fromDate, toDate]);

    return (
        <div>
            <Radio.Group onChange={onChange} value={value} style={style}>
                <Radio value={1}>Preset Range</Radio>
                {value === 1 && (
                    <>
                        <Paragraph
                            style={{ marginBottom: "4px", color: "#090A09" }}
                        >
                            Select Range
                        </Paragraph>
                        <Select
                            defaultValue="Today"
                            style={{ width: "100%", marginBottom: "32px" }}
                            rootClassName="custom-select"
                            options={presetRanges}
                            onChange={handleChangePresetRange}
                        />
                    </>
                )}
                <Radio value={2}>Custom Range</Radio>
                {value === 2 && (
                    <>
                        <Paragraph
                            style={{ marginBottom: "4px", color: "#090A09" }}
                        >
                            From
                        </Paragraph>
                        <DatePicker
                            size="middle"
                            onChange={handleChangeFromDate}
                        />
                        <Paragraph
                            style={{ marginBottom: "4px", color: "#090A09" }}
                        >
                            To
                        </Paragraph>
                        <DatePicker
                            size="middle"
                            onChange={handleChangeToDate}
                        />
                    </>
                )}
            </Radio.Group>
        </div>
    );
};
